<template>
  <nav ref="navMenu" :class="isHamburgerVisible ? 'revealAnimation' : ''">
    <a class="closeHamburgerMenu pointer" @click="hideHamburgerMenu"><span></span><span></span><span></span></a>
    <div class="myPatientNav">
      <div class="nav_title">
        <h6 class="--white">
          <a class="pointer" @click="clickNavMenu(0, 'Home')">{{ $t('patients.patient') }}</a>
        </h6>
      </div>
      <ul class="nav_gnb" style="scroll-behavior: smooth;">
        <li v-bind:class="[navMenu === 0 ? this.classes.active : this.classes.none]" @click="clickNavMenu(0, 'Home')"
            class="pointer">
          <div class="bl_i">
            <img src="../../assets/images/nav_i_01.png" alt="nav_i_1">
          </div>
          <span>
              {{ $t('patient.home') }}
          </span>
        </li>
        <li v-bind:class="[navMenu === 1 ? this.classes.active : this.classes.none]" @click="clickNavMenu(1, 'Info')"
            class="pointer">
          <div class="bl_i">
            <img src="../../assets/images/nav_i_02.png" alt="nav_i_2">
          </div>
          <span>
              {{ $t('patient.info.info') }}
          </span>
        </li>
        <li v-bind:class="[navMenu === 2 ? this.classes.active : this.classes.none]" @click="clickNavMenu(2, 'Note')"
            class="pointer">
          <div class="bl_i">
            <img src="../../assets/images/nav_i_03.png" alt="nav_i_3">
          </div>
          <span>
              {{ $t('patient.note') }}
          </span>
        </li>
        <li v-bind:class="[navMenu === 3 ? this.classes.active : this.classes.none]" @click="clickNavMenu(3, 'Remote')"
            class="pointer">
          <div class="bl_i">
            <img src="../../assets/images/nav_i_04.png" alt="nav_i_4">
          </div>
          <span>{{ $t('patient.RMC') }}</span>

        </li>
        <li v-bind:class="[navMenu === 4 ? this.classes.active : this.classes.none]" @click="clickNavMenu(4, 'Rehab')"
            class="pointer">
          <div class="bl_i">
            <img src="../../assets/images/nav_i_05.png" alt="nav_i_5">
          </div>
          <span>{{ $t('patient.rehab') }}</span>
        </li>
        <li v-bind:class="[navMenu === 5 ? this.classes.active : this.classes.none]" @click="clickNavMenu(5, 'History')"
            class="pointer">
          <div class="bl_i">
            <img src="../../assets/images/nav_i_06.png" alt="nav_i_6">
          </div>
          <span>{{ $t('patient.rehabilitation_history') }}</span>
        </li>
        <li v-bind:class="[navMenu === 6 ? this.classes.active : this.classes.none]" @click="clickNavMenu(6, 'Report')"
            class="pointer">
          <div class="bl_i">
            <img src="../../assets/images/nav_i_07.png" alt="nav_i_7">
          </div>
          <span>{{ $t('patient.report') }}</span>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  data() {
    return {
      navMenu: 0,
      navMenuArr: [
          'home',
          'info',
          'note',
          'remote',
          'rehab',
          'history',
          'report'
      ],
      classes: {
        active: 'active pointer',
        none: 'pointer'
      },
      isHamburgerVisible: false
    }
  },
  methods: {
    ...mapActions(['changeNavMenu', 'setHamburgerVisible']),
    ...mapGetters(['getNavMenu']),
    clickNavMenu(idx, id) {
      const content = document.getElementById(`patientListDetails`);
      const section = document.getElementById(`section${id}`);
      content.scrollTo(0, section.offsetTop);

      this.navMenu = idx;
      this.hideHamburgerMenu();
    },
    hideHamburgerMenu() {
      this.setHamburgerVisible(false);
      this.$modal.hide('blank-modal');
    },
  },
  watch: {
    isHamburgerVisible(newData) {
      this.isHamburgerVisible = newData;
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((_mutation, state) => {
      this.isHamburgerVisible = state.isHamburgerVisible;
    })
  },
  beforeDestroy() {
    this.unsubscribe();
  },
}
</script>
<style lang="scss">
@import "@/scss/navi";

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>

